import React from 'react';
import { Button } from '../ui/button';
import { BusinessHours } from '../BusinessHours';
import { directionsUrl, locations } from '../../data/site';

export const HomeLocations = () => (
  <>
    <section className="reference-section" id="locations" data-testid="home-locations"><div className="site-container">
      <div className="reference-heading"><h2>Two shops.<br /><em>One standard.</em></h2><p>Walk-ins welcome at both. Call ahead if you're in a hurry and we'll have a bay ready.</p></div>
      <div className="reference-locations-grid">{locations.map((location) => <article className="reference-location" key={location.id} data-testid={`home-location-${location.id}`}>
        <h3>{location.name}</h3><address data-testid={`home-location-${location.id}-address`}>{location.address}<br />{location.city}</address>
        <div className="reference-actions"><Button asChild className="brand-button"><a href={location.tel} data-testid={`home-location-${location.id}-call`}>{location.phone}</a></Button>
          <Button asChild className="brand-button outline-button"><a href={directionsUrl(location)} target="_blank" rel="noopener noreferrer" data-testid={`home-location-${location.id}-directions`}>Directions</a></Button>
        </div><BusinessHours testId={`home-location-${location.id}-hours`} />
      </article>)}</div>
    </div></section>
    <section className="reference-final" data-testid="home-final-cta"><div className="site-container">
      <h2>Walk in.<br /><em>Roll out.</em></h2><p>Two shops, one crew, zero nonsense. Your car will thank you.</p>
      <div className="reference-actions">{locations.map((location, index) => <Button asChild className={`brand-button ${index ? 'outline-button' : ''}`} key={location.id}>
        <a href={location.tel} data-testid={`home-final-call-${location.id}`}>Call {location.name}</a>
      </Button>)}</div>
    </div></section>
  </>
);